import dummymakler1Image from '../assets/images/dummymakler1.png';
import dummymakler2Image from '../assets/images/dummymakler2.png';
import dummymakler3Image from '../assets/images/dummymakler3.png';
import dummymakler4Image from '../assets/images/dummymakler4.png';

export const dummymakler1 = {
  firstName: 'Gerhard',
  lastName: 'Mühlbauer',
  profilePictureFileId: dummymakler1Image,
};

export const dummymakler2 = {
  firstName: 'Marcel',
  lastName: 'Neureiter',
  profilePictureFileId: dummymakler2Image,
};

export const dummymakler3 = {
  firstName: 'Monika',
  lastName: 'Wallner',
  profilePictureFileId: dummymakler3Image,
};

/* ABGEBER */
export const dummymakler4 = {
  firstName: 'Sabine',
  lastName: 'Hofer',
  profilePictureFileId: dummymakler4Image,
};
